export const isSentryInstalled = () =>
  !!(typeof window !== 'undefined' && window.__sentry_installed__);
